import { createAction } from 'redux-actions';

export const setRefetchOpportunities = createAction<() => void>('SET_REFETCH_OPPORTUNITIES');
export const setRefetchShortOpportunities = createAction<() => void>(
  'SET_REFETCH_SHORT_OPPORTUNITIES'
);
